// Styles
import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";

// Vuetify
import { createVuetify } from "vuetify";

export default createVuetify({
  theme: {
    themes: {
      dark: {
        colors: {
          background: "#121212", // Тёмный фон
          surface: "#121212", // Цвет поверхностей
        },
      },
    },
  },
  font: {
    family: "SF UI Display", // Указываем шрифт
  },
});
